import { createContext, useContext, useState } from 'react';

const TracksContext = createContext();

export const useTracks = () => {
  const context = useContext(TracksContext);
  if (!context) {
    throw new Error('useTracks must be used within TracksProvider');
  }
  return context;
};

export const TracksProvider = ({ children }) => {
  const [tracks, setTracks] = useState([]);

  return (
    <TracksContext.Provider value={{ tracks, setTracks }}>
      {children}
    </TracksContext.Provider>
  );
};
